import { throttle } from 'min-dash';
/**
 * A factory to create a configurable throttler.
 *
 * @param {number|boolean} [config=true]
 */

export default function ThrottleFactory() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var timeout = typeof config === 'number' ? config : config ? 300 : 0;

  if (timeout) {
    return function (fn) {
      return throttle(fn, timeout);
    };
  } else {
    return function (fn) {
      return fn;
    };
  }
}
ThrottleFactory.$inject = ['config.throttle'];
//# sourceMappingURL=Throttle.js.map